export let itemListProps = {
    key: 0,
    id: 0,
    production_id: null,
    work_order_number: null,
    production_work_log_id: 0,
    work_order_process_id: 0,
    sub_tailoring_item_id: 0,
    tailoring_item_id: 0,
    finished: false
}

export let dataProps = {
    id: 0,
    store_id: null,
    challan_number: null, 
    sourcing_date: new Date(), 
    expected_return_date: new Date(), 
    staff_id: null,
    sourced_by_staff_id: null, 
    notes: '',
    status: 0, 
    process_id: null,
    
    item_list: [],
}


// WEBPACK FOOTER //
// ./src/store/modules/productionOutsource/properties.js